'use client';
import { Input } from "@/components/ui/input";
import { Button } from "@/components/ui/button";
import { Search } from "lucide-react";
import React, { useEffect, useState } from "react";
import Link from "next/link";  // Importa il router

export default function SearchBoxHome({className}: {className?: string}) {
    const [searchQuery, setSearchQuery] = useState<string>('');
    const [searchResults, setSearchResults] = useState<any[]>([]);
    const [showResults, setShowResults] = useState<boolean>(false);
    const [error, setError] = useState<string | null>(null); // Stato per l'errore

    const handleSearch = async () => {
        try {
            setError(null); // Resetta l'errore prima di fare la chiamata
            if (searchQuery.trim() !== '') {
                const response = await fetch(`${process.env.NEXT_PUBLIC_API_URL}/api/articoli/search?q=${encodeURIComponent(searchQuery.trim())}`);

                if (!response.ok) {
                    throw new Error('Errore nella ricerca, riprova più tardi.');
                }

                const data = await response.json();

                if (data.data.length === 0) {
                    setError('Nessun risultato trovato.');
                    setShowResults(true);
                } else {
                    setSearchResults(data.data);
                    setShowResults(true);
                }
            } else {
                setShowResults(false);
            }
        } catch (err: any) {
            setError(err.message || 'Errore nella ricerca, riprova più tardi.');
            setSearchResults([]);
            setShowResults(true);
        }
    };

    useEffect(() => {
        if (searchQuery.length < 2) {
            setShowResults(false);
        }

        if (searchQuery.trim() === '') {
            setShowResults(false);
        }

        if (searchQuery.trim() !== '') {
            handleSearch();
        }
    }, [searchQuery]);


    return (
        <div className="relative max-w-4xl mx-auto">
            <div className={`flex items-center rounded-full bg-white px-1.5 py-3 shadow ${className}`}>
                <Input
                    className="flex-1 bg-transparent max-h-[50px] !border-0 text-lg leading-tight focus:outline-none focus-visible:ring-offset-0 focus-visible:ring-0 !py-0"
                    placeholder="Quale auto cerchi?"
                    value={searchQuery}
                    onChange={(e) => setSearchQuery(e.target.value)}
                    onFocus={() => searchQuery && setShowResults(true)}
                />
                <Button className="shrink-0 bg-primary rounded-full p-2" variant="secondary" aria-label="Cerca"
                        aria-labelledby="search-label" onClick={handleSearch}>
                    <Search className="text-white"/>
                </Button>
                <span id="search-label" className="sr-only">Cerca</span>
            </div>


            {showResults && (
                <div
                    className="results-container absolute left-0 right-0 mt-2 bg-white shadow-lg rounded-lg max-h-60 overflow-y-auto z-10 px-4 py-4 "
                    style={{ width: "100%" }}
                >
                    {error ? (
                        <div className="p-2 text-red-600">Nessun risultato di ricerca per <strong>{searchQuery}</strong> </div>
                    ) : (
                        searchResults.length > 0 ? (
                            searchResults.map((result, index) => (
                                <Link key={index} className="p-2 cursor-pointer" href={result.url} hrefLang="it">
                                    <p>{result.marca} {result.modello}</p>
                                </Link>
                            ))
                        ) : (
                            <div className="p-2">Nessun risultato trovato.</div>
                        )
                    )}
                </div>
            )}
        </div>
    );
}
